// Return payment-success page (GW-480 #8) - the PUBLIC storefront page TJ redirects
// the customer to after paying the courier fee. The storefront `Session` cookie is
// SameSite=Strict, so the login-gated returns page would bounce the cross-site return
// to a login wall; this page is public instead. It reads `?return=<id>` from the URL
// and confirms the payment via the public POST /api/returns/:id/confirm-payment (the
// TJ payment verification is the authorisation - no session needed), then renders the
// result inline. Mount by dropping
//     <div data-pf-return-payment></div>
// on the /log-a-return-payment-success page.
import { getTopDocument } from '../shared/dom.js';
import { apiFetch } from '../shared/api.js';

export var id = 'log-return-payment-success';

var NAVY = '#001689';

export function init() {
  var doc = getTopDocument();
  var markers = doc.querySelectorAll('[data-pf-return-payment]');
  if (!markers || markers.length === 0) return;
  var win = doc.defaultView || window;

  var params = null;
  try { params = new URLSearchParams(win.location.search); } catch (e) { /* ignore */ }
  var returnId = (params && params.get('return')) || '';
  var cancelled = !!(params && params.get('payment') === 'cancelled');

  for (var i = 0; i < markers.length; i++) handle(markers[i], returnId, cancelled);
}

function handle(el, returnId, cancelled) {
  if (!returnId) {
    el.innerHTML = card('warn', 'Payment', 'We couldn’t find your return reference. Open “My Returns” in your account to check the status.');
    return;
  }
  if (cancelled) {
    el.innerHTML = card('warn', 'Payment cancelled', 'Your payment was cancelled and you have not been charged. Open “My Returns” to try again when you’re ready.');
    return;
  }

  el.innerHTML = card('ok', 'Confirming your payment…', 'Please wait while we confirm your payment and book your courier collection.');

  apiFetch('/api/returns/' + encodeURIComponent(returnId) + '/confirm-payment', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: '{}',
  }).then(function (r) {
    return r.json().then(function (d) { return d; }, function () { return {}; });
  }).then(function (d) {
    d = d || {};
    if (d.paid && d.waybillNo) {
      var track = d.trackingUrl
        ? '<a href="' + esc(d.trackingUrl) + '" target="_blank" rel="noreferrer" style="display:inline-block;margin-top:10px;color:' + NAVY + ';font-weight:700;text-decoration:none;">Track your return →</a>'
        : '';
      el.innerHTML = card('ok', 'Payment received',
        'Thank you - your payment is confirmed and your courier collection is booked.' +
        '<div style="margin-top:14px;padding:12px 14px;background:#f1f9f4;border:1px solid #cfe3d3;border-radius:8px;">' +
        '<div style="font-size:11px;text-transform:uppercase;letter-spacing:.5px;color:#6c757d;">Waybill</div>' +
        '<div style="font-weight:700;font-size:18px;color:' + NAVY + ';">' + esc(d.waybillNo) + '</div>' + track +
        '</div>');
    } else {
      el.innerHTML = card('warn', 'Payment processing',
        'Thanks - you’re back from the payment page. We’re finalising your payment and booking your courier collection, which can take a moment. Open “My Returns” in your account shortly to see your waybill and tracking.');
    }
  }).catch(function () {
    el.innerHTML = card('warn', 'Payment processing',
      'We couldn’t confirm your payment just now. If you were charged, your return will still be processed - check “My Returns” in your account.');
  });
}

function esc(s) {
  return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
    return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
  });
}

function card(tone, title, bodyHtml) {
  var bar = tone === 'ok' ? '#1f9d55' : tone === 'warn' ? '#d99a00' : '#d9272e';
  var myReturns = '<a href="/returns-history" style="display:inline-block;margin-top:18px;padding:10px 18px;background:' + NAVY + ';color:#fff;font-weight:700;text-decoration:none;border-radius:8px;font-size:14px;">View My Returns</a>';
  return '<div style="max-width:520px;margin:24px auto;background:#fff;border-radius:10px;overflow:hidden;box-shadow:0 1px 3px rgba(0,0,0,.08);font-family:-apple-system,BlinkMacSystemFont,\'Segoe UI\',Roboto,sans-serif;color:#1a1a1a;">' +
    '<div style="background:' + NAVY + ';height:6px;border-bottom:3px solid ' + bar + ';"></div>' +
    '<div style="padding:24px 26px;">' +
    '<div style="font-size:11px;text-transform:uppercase;letter-spacing:1px;color:#6c757d;margin-bottom:8px;">Goldwagen · Returns</div>' +
    '<h1 style="margin:0 0 10px;font-size:22px;color:' + NAVY + ';">' + esc(title) + '</h1>' +
    '<div style="font-size:15px;line-height:1.6;">' + bodyHtml + '</div>' +
    myReturns +
    '</div></div>';
}
